import { Component } from '@angular/core';
import { LandingPageComponent } from '../pages/landing-page/landing-page.component';
import { SideBarComponent } from '../components/side-bar/side-bar.component';
import { SpinnerComponent } from '../components/spinner/spinner.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HomeComponent } from '../pages/home/home.component';
import { FooterComponent } from '../components/footer/footer.component';
import { Router } from '@angular/router';
import { Inject } from '@angular/core';
@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [SideBarComponent, CommonModule, RouterModule],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent {
  result: string | null = null;
  constructor(@Inject(Router) public router: Router) { }
  onSpinEnd(prize: string) {
    this.result = prize;
  }

  isSpinnerModule() {
    const current = this.router.url;
    return current === '/dashboard/spinner' || current === '/dashboard/home';
  }

  isTreasurePickRoute(): boolean {
    const current = this.router.url;
    return current === '/dashboard/TreasurePick' || current === '/dashboard/Avaitar' || current === '/dashboard/Baccaret'  || current === '/dashboard/Keno' || current === '/dashboard/Roulette' || current === '/dashboard/Mines' || current === '/dashboard/Plinko' || current === '/dashboard/StackBuilder';
  }

  isHiddenSidebarRoute(): boolean {
    const current = this.router.url;
    return (
      current === '/dashboard/Terms&Conditions' ||
      current === '/dashboard/PrivacyPolicy' ||
      current === '/dashboard/help-support'
    );
  }
}
